import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime, Info } from 'luxon';

class DateAdapter extends AdapterLuxon {
	// Override to handle null/undefined - parent uses class field so super.setTimezone is not on prototype
	setTimezone = ((value: DateTime | null | undefined, timezone: string) => {
		if (value == null || value.zone == null) {
			return value;
		}
		if (!value.zone.equals(Info.normalizeZone(timezone))) {
			return value.setZone(timezone);
		}
		return value;
	}) as AdapterLuxon['setTimezone'];
}

export default DateAdapter;
